/* eslint-disable react/prefer-es6-class, react/prop-types */
import React from 'react';
import Localization from 'es6/services/localization';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import ItemSummary from 'es6/components/apps/item-summary';

const DEFAULT_PROPS = Object.assign(
  {
    onQuit: React.PropTypes.func.isRequired,
  },
  ItemSummary.propTypes
);

const ItemSummaryScreen = React.createClass({
  displayName: 'ItemSummaryScreen',

  defaultProps: DEFAULT_PROPS,

  render() {
    const { props } = this;

    return (
      <div className="screen screen-item-summary">
        <div className="screen-content">
          <ItemSummary {...props} />
        </div>

        <Navigation>
          <NavButton align="right" focused onClick={this.props.onQuit}>
            {Localization.t('item-summary-screen.quit')}
          </NavButton>
        </Navigation>
      </div>
    );
  },
});

export default ItemSummaryScreen;
